import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "emergency_service_content" }
const _hoisted_2 = { class: "emergency_service_editor" }
const _hoisted_3 = { class: "custom_dropdown custom_column custom_dropdown-property" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Select Property")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "custom_dropdown_content"
}
const _hoisted_6 = { class: "custom_dropdown_content_inner" }
const _hoisted_7 = { class: "custom_dropdown_search" }
const _hoisted_8 = {
  key: 0,
  class: "custom_dropdown_select_all"
}
const _hoisted_9 = { class: "custom_dropdown_list" }
const _hoisted_10 = { class: "custom_dropdown custom_column custom_dropdown-specialisms" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Select Specialisms")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "custom_dropdown_content"
}
const _hoisted_13 = { class: "custom_dropdown_content_inner" }
const _hoisted_14 = { class: "custom_dropdown_search" }
const _hoisted_15 = { class: "custom_dropdown_list" }
const _hoisted_16 = { class: "custom_dropdown__heading" }
const _hoisted_17 = { class: "custom_dropdown__title" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "custom_dropdown__title_text" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "custom_dropdown__content" }
const _hoisted_22 = { class: "emergency_date_time_picker custom_column" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Date & Time ", -1)
const _hoisted_25 = { class: "date_time_selector" }
const _hoisted_26 = { class: "weekdays" }
const _hoisted_27 = { class: "weekdays_wrapper" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Weekdays", -1)
const _hoisted_29 = { class: "allday_selector" }
const _hoisted_30 = { class: "days" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "time-range" }
const _hoisted_33 = { class: "time-select" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "AM" }, "AM", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "PM" }, "PM", -1)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "To", -1)
const _hoisted_38 = { class: "time-select" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "AM" }, "AM", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "PM" }, "PM", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "emergency_service_manual custom_column" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "SLATime" }, "SLA Time (Manual Intervention)", -1)
const _hoisted_45 = { class: "emergency_service_time_inputs" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, ":", -1)
const _hoisted_47 = { class: "emergency_service_budget custom_column" }
const _hoisted_48 = { class: "title" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "SLATime" }, "Earmark Budget*", -1)
const _hoisted_50 = { class: "emergency_service_fee custom_column" }
const _hoisted_51 = { class: "title" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", null, "Emergency call out fee*", -1)
const _hoisted_53 = { class: "emergency_service_rate custom_column" }
const _hoisted_54 = { class: "title" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "ECOR" }, "Emergency call out rate*", -1)
const _hoisted_56 = { class: "custom_dropdown custom_column custom_dropdown-contractor" }
const _hoisted_57 = { class: "title" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Preferred Contractor", -1)
const _hoisted_59 = {
  key: 0,
  class: "custom_dropdown_content"
}
const _hoisted_60 = { class: "custom_dropdown_content_inner" }
const _hoisted_61 = { class: "custom_dropdown_search" }
const _hoisted_62 = { class: "custom_dropdown_select_all" }
const _hoisted_63 = { class: "custom_dropdown_list" }
const _hoisted_64 = { class: "custom_dropdown__checkbox-label" }
const _hoisted_65 = { class: "custom_dropdown__checkbox-image" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "custom_dropdown custom_column custom_dropdown-contractor custom_dropdown-occupier" }
const _hoisted_68 = { class: "title" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", null, "Select Occupier", -1)
const _hoisted_70 = {
  key: 0,
  class: "custom_dropdown_content"
}
const _hoisted_71 = { class: "custom_dropdown_content_inner" }
const _hoisted_72 = { class: "custom_dropdown_search" }
const _hoisted_73 = { class: "custom_dropdown_list" }
const _hoisted_74 = { class: "custom_dropdown__checkbox-label" }
const _hoisted_75 = { class: "custom_dropdown__checkbox-image" }
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "emergency_footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    class: "emergency_service_modal",
    title: !$props.selectedEventId ? `Add New` : `Edit Out Of Hours`,
    width: "570px",
    onClickBackButton: $setup.onClickCancel
  }, {
    body: _withCtx(() => [
      _createVNode(_component_v_form, {
        rules: $setup.validation,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_text_field, {
              modelValue: $setup.eventFrom.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.eventFrom.title) = $event)),
              placeholder: "Add Title",
              variant: "underlined",
              rules: $setup.validation.title,
              class: "emergency_service_input"
            }, null, 8, ["modelValue", "rules"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_quill_editor, {
                value: $setup.eventFrom.description,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.eventFrom.description) = $event)),
                rules: $setup.validation.description
              }, null, 8, ["value", "rules"])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", {
                class: _normalizeClass(["custom_dropdown_trigger", { 'is-open': $setup.isShowPropertyDropdownOpen }]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.togglePropertyDropdown && $setup.togglePropertyDropdown(...args)))
              }, [
                _createElementVNode("p", null, _toDisplayString($setup.eventFrom.EOHProperties.length
                    ? $setup.selectedPropertyName
                    : "Please Select Property"), 1),
                _createVNode(_component_v_icon, { icon: "mdi-chevron-down" })
              ], 2),
              ($setup.isShowPropertyDropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_text_field, {
                          class: "custom_input",
                          variant: "outlined",
                          "bg-color": "#F5F6F8",
                          placeholder: "Search Property",
                          "prepend-inner-icon": "mdi-magnify",
                          modelValue: $setup.propertySearch,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.propertySearch) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      ($setup.filterProperties.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_v_checkbox, {
                              color: "#4F55F0",
                              label: "Select All",
                              modelValue: $setup.isSelectAllProperties,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.isSelectAllProperties) = $event)),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.onChangeSelectAllProperties()))
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterProperties, (property) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: property.id
                          }, [
                            _createVNode(_component_v_checkbox, {
                              color: "#4F55F0",
                              modelValue: $setup.eventFrom.EOHProperties,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.eventFrom.EOHProperties) = $event)),
                              label: property.address,
                              value: property.id
                            }, null, 8, ["modelValue", "label", "value"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_click_outside, $setup.closeSelectProperty]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", {
                class: _normalizeClass(["custom_dropdown_trigger", { 'is-open': $setup.isDropdownOpen }]),
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.toggleDropdown && $setup.toggleDropdown(...args)))
              }, [
                _createElementVNode("p", null, _toDisplayString($setup.eventFrom.EOHSpecialism.length
                    ? $setup.selectedSubCategoryName
                    : "Select Specialisms"), 1),
                _createVNode(_component_v_icon, { icon: "mdi-chevron-down" })
              ], 2),
              ($setup.isDropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_text_field, {
                          class: "custom_input",
                          variant: "outlined",
                          "bg-color": "#F5F6F8",
                          placeholder: "Search Specialisms",
                          "prepend-inner-icon": "mdi-magnify",
                          modelValue: $setup.searchCategory,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.searchCategory) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_v_expansion_panels, { multiple: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterCategory, (specialism) => {
                              return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                key: specialism.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_v_checkbox, {
                                          color: "#4B4BFF",
                                          modelValue: $setup.selectedMainCategory,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.selectedMainCategory) = $event)),
                                          value: specialism.id,
                                          onClick: ($event: any) => ($setup.onClickMainCategory(specialism.id))
                                        }, null, 8, ["modelValue", "value", "onClick"]),
                                        _createElementVNode("div", _hoisted_17, [
                                          (specialism.iconName)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                class: "custom_dropdown__title_icon"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    style: {"width":"14px"},
                                                    src: 
                                  require('@/assets/category-icons/' +
                                    specialism.iconName +
                                    '.svg')
                                ,
                                                    alt: "icon"
                                                  }, null, 8, _hoisted_18)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("h2", null, _toDisplayString(specialism.poLabel), 1),
                                            _createElementVNode("p", null, [
                                              _createTextVNode(_toDisplayString(specialism.subCategories
                                    .slice(0, 2)
                                    .map((sub) => sub.label)
                                    .join(", ")) + " ", 1),
                                              (specialism.subCategories?.length > 2)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, " etc.."))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_21, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialism.subCategories, (subCategory) => {
                                          return (_openBlock(), _createBlock(_component_v_checkbox, {
                                            color: "#4B4BFF",
                                            modelValue: $setup.eventFrom.EOHSpecialism,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.eventFrom.EOHSpecialism) = $event)),
                                            label: subCategory.label,
                                            key: subCategory.id,
                                            value: subCategory.id
                                          }, null, 8, ["modelValue", "label", "value"]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_click_outside, $setup.closeSelectSpecialisms]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.everyday) = $event)),
                        onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.onChangeCheckbox && $setup.onChangeCheckbox(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, $setup.everyday]
                      ]),
                      _createTextVNode(" Everyday ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.days, (day, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: index,
                        class: _normalizeClass({ selected: $setup.isDaySelected(day.value) }),
                        onClick: ($event: any) => ($setup.toggleDay(day.value))
                      }, _toDisplayString(day.name), 11, _hoisted_31))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.eventTime.startHour) = $event)),
                      min: "1",
                      max: "12",
                      onInput: _cache[14] || (_cache[14] = ($event: any) => ($setup.onChangeEventTime()))
                    }, null, 544), [
                      [_vModelText, $setup.eventTime.startHour]
                    ]),
                    _createTextVNode(" : "),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.eventTime.startMinute) = $event)),
                      min: "0",
                      max: "60",
                      onInput: _cache[16] || (_cache[16] = ($event: any) => ($setup.onChangeEventTime()))
                    }, null, 544), [
                      [_vModelText, $setup.eventTime.startMinute]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.eventTime.startDay) = $event))
                    }, _hoisted_36, 512), [
                      [_vModelSelect, $setup.eventTime.startDay]
                    ])
                  ]),
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.eventTime.endHour) = $event)),
                      min: "1",
                      max: "12",
                      onInput: _cache[19] || (_cache[19] = ($event: any) => ($setup.onChangeEventTime()))
                    }, null, 544), [
                      [_vModelText, $setup.eventTime.endHour]
                    ]),
                    _createTextVNode(" : "),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.eventTime.endMinute) = $event)),
                      min: "0",
                      max: "59",
                      onInput: _cache[21] || (_cache[21] = ($event: any) => ($setup.onChangeEventTime()))
                    }, null, 544), [
                      [_vModelText, $setup.eventTime.endMinute]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.eventTime.endDay) = $event))
                    }, _hoisted_41, 512), [
                      [_vModelSelect, $setup.eventTime.endDay]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_v_text_field, {
                  class: "custom_input",
                  variant: "outlined",
                  placeholder: "Hours",
                  type: "number",
                  min: "0",
                  max: "12",
                  modelValue: $setup.slaTimeHours,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.slaTimeHours) = $event)),
                  modelModifiers: { number: true },
                  onInput: _cache[24] || (_cache[24] = ($event: any) => ($setup.onChangeEventSlaTime()))
                }, null, 8, ["modelValue"]),
                _hoisted_46,
                _createVNode(_component_v_text_field, {
                  class: "custom_input",
                  variant: "outlined",
                  placeholder: "Minutes",
                  type: "number",
                  min: "0",
                  max: "60",
                  modelValue: $setup.slaTimeMinutes,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.slaTimeMinutes) = $event)),
                  modelModifiers: { number: true },
                  onInput: _cache[26] || (_cache[26] = ($event: any) => ($setup.onChangeEventSlaTime()))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createVNode(_component_v_text_field, {
                rules: $setup.validation.budget,
                modelValue: $setup.formattedBudget,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.formattedBudget) = $event)),
                class: "custom_input",
                variant: "outlined",
                placeholder: "£1,000.00",
                onInput: _cache[28] || (_cache[28] = ($event: any) => ($setup.formatBudget($event)))
              }, null, 8, ["rules", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createVNode(_component_v_text_field, {
                modelValue: $setup.formattedEmergencyCallOutFee,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.formattedEmergencyCallOutFee) = $event)),
                rules: $setup.validation.emergencyCallOutFee,
                class: "custom_input",
                variant: "outlined",
                placeholder: "£100.00",
                onInput: _cache[30] || (_cache[30] = ($event: any) => ($setup.formatEmergencyCallOutFee($event)))
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createVNode(_component_v_text_field, {
                modelValue: $setup.formattedEmergencyCallOutRate,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.formattedEmergencyCallOutRate) = $event)),
                rules: $setup.validation.emergencyCallOutRate,
                class: "custom_input",
                variant: "outlined",
                placeholder: "£50.00 / hour",
                onInput: _cache[32] || (_cache[32] = ($event: any) => ($setup.formatEmergencyCallOutRate($event)))
              }, null, 8, ["modelValue", "rules"])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["custom_dropdown_trigger", { 'is-open': $setup.isPreferredDropdownOpen }]),
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => ($setup.togglePreferredDropdown && $setup.togglePreferredDropdown(...args)))
              }, [
                _createElementVNode("p", null, _toDisplayString($setup.selectedPreferredContractor.length
                    ? $setup.selectedPreferredContractorName
                    : "Select Preferred Contractor"), 1),
                _createVNode(_component_v_icon, { icon: "mdi-chevron-down" })
              ], 2),
              ($setup.isPreferredDropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_v_text_field, {
                          class: "custom_input",
                          variant: "outlined",
                          "bg-color": "#F5F6F8",
                          placeholder: "Search Specialisms",
                          "prepend-inner-icon": "mdi-magnify",
                          modelValue: $setup.searchPreferredContractor,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.searchPreferredContractor) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_v_checkbox, {
                          color: "#4F55F0",
                          label: "Select All",
                          modelValue: $setup.selectAllPreferredContractor,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.selectAllPreferredContractor) = $event)),
                          onChange: $setup.onChangeSelectAllPreferredContractor
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _createElementVNode("ul", _hoisted_63, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterPreferredContractor, (preferredContractor) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: preferredContractor.id
                          }, [
                            _createVNode(_component_v_checkbox, {
                              color: "#4F55F0",
                              modelValue: $setup.selectedPreferredContractor,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.selectedPreferredContractor) = $event)),
                              value: preferredContractor.userWorkstation.id
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("img", {
                                      src: 
                                preferredContractor.userWorkstation.publicURL
                              ,
                                      alt: "Image",
                                      width: "20",
                                      height: "20"
                                    }, null, 8, _hoisted_66)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(preferredContractor.userWorkstation.name), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "value"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_click_outside, $setup.closePreferredContractor]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["custom_dropdown_trigger", { 'is-open': $setup.isShowSelectOccupierDropdown }]),
                onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => ($setup.toggleOccupierDropdown && $setup.toggleOccupierDropdown(...args)))
              }, [
                _createElementVNode("p", null, _toDisplayString($setup.eventFrom.EOHPropertyOccupier.length
                    ? $setup.selectedOccupierName
                    : "Select Occupier"), 1),
                _createVNode(_component_v_icon, { icon: "mdi-chevron-down" })
              ], 2),
              ($setup.isShowSelectOccupierDropdown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_v_text_field, {
                          class: "custom_input",
                          variant: "outlined",
                          "bg-color": "#F5F6F8",
                          placeholder: "Search Occupier",
                          "prepend-inner-icon": "mdi-magnify",
                          modelValue: $setup.searchOccupier,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.searchOccupier) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("ul", _hoisted_73, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterOccupier, (occupier) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: occupier.userId
                          }, [
                            _createVNode(_component_v_checkbox, {
                              color: "#4F55F0",
                              modelValue: $setup.eventFrom.EOHPropertyOccupier,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.eventFrom.EOHPropertyOccupier) = $event)),
                              value: occupier.userId
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("img", {
                                      src: occupier.publicURL,
                                      alt: "Image",
                                      width: "20",
                                      height: "20"
                                    }, null, 8, _hoisted_76)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(occupier.name), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "value"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_click_outside, $setup.closeSelectOccupier]
            ])
          ])
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_77, [
        _createVNode(_component_Button, {
          label: "CANCEL",
          class: "button",
          variant: "secondary",
          onClick: $setup.onClickCancel
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "POST",
          class: "button",
          onClick: $setup.onClickPostButton,
          variant: "accent"
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["title", "onClickBackButton"]))
}